
const STORAGE_KEY_AUTH = 'psico_auth_token';
const STORAGE_KEY_NAME = 'psico_auth_name';
const STORAGE_KEY_USERNAME = 'psico_auth_username';

export const login = async (username: string, password: string): Promise<boolean> => {
  try {
    const res = await fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });

    if (res.ok) {
      const data = await res.json();
      sessionStorage.setItem(STORAGE_KEY_AUTH, data.token);
      if (data.user) {
        sessionStorage.setItem(STORAGE_KEY_NAME, data.user.name || 'Administrador');
        sessionStorage.setItem(STORAGE_KEY_USERNAME, data.user.username || username);
      }
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const logout = (): void => {
  sessionStorage.removeItem(STORAGE_KEY_AUTH);
  sessionStorage.removeItem(STORAGE_KEY_NAME);
  sessionStorage.removeItem(STORAGE_KEY_USERNAME);
};

export const isAuthenticated = (): boolean => {
  return !!sessionStorage.getItem(STORAGE_KEY_AUTH);
};

export const getUserName = (): string => {
  return sessionStorage.getItem(STORAGE_KEY_NAME) || 'Administrador';
};

export const getAuthToken = (): string | null => {
  return sessionStorage.getItem(STORAGE_KEY_AUTH);
};

export const authenticatedFetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  const response = await fetch(input, init);
  if ((response.status === 401 || response.status === 403) && new Headers(init?.headers).has('Authorization')) {
    logout();
    window.dispatchEvent(new Event('auth-session-expired'));
  }
  return response;
};

export const getUserDetails = () => {
  return {
    name: sessionStorage.getItem(STORAGE_KEY_NAME) || 'Administrador',
    username: sessionStorage.getItem(STORAGE_KEY_USERNAME) || 'admin',
    role: 'Profissional'
  };
};

export const changePassword = async (oldPassword: string, newPassword: string): Promise<void> => {
  const token = getAuthToken();
  const res = await authenticatedFetch('/api/admin/password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ oldPassword, newPassword })
  });

  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.message || 'Erro ao alterar a senha.');
  }
};
